const initialState = () => ({
  shTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: [],
    sortDesc: [],
  },
  showActionModal: false,
  actionModalView: '',
  processing: false,
  actionDismissReason: '',
  unmuteDate: '',
  status: '',
  actionNote: '',
  completedProfile: [],
  incompletedProfile: [],
  completeAlertsCount: {},
  incompleteAlertsCount: {},
  shTableSearch: '',
  activeProfileTab: 'complete',
  activeAlertTab: 'all',
  activeHealthTab: '',
  activeCorpFilter: 'all',
  allSystemHealth: [],
  tableData: [],
  activeCorpSystemHealth: [],
  leakAlertCount: 0,
  performanceAlertCount: 0,
  filterAlertCount: 0,
  batteryAlertCount: 0,
  deviceAlertCount: 0,
  customer: null,
  filters: [],
  hvac: null,
  notifications: [],
  currentExpandedRowId: 0,
  systemHealthExpandableData: new Map(),
  iHaveEverything: new Map(),
  chronicAlerts: [],
  loading: true,
  expandableLoading: true,
  resetSystemHealthFlag: false,
  sortedCorporation: [],
  selectedCorp: null,
  systemHealthTableHeaders: [
    {
      text: 'MEMBER',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'customer.name',
    },
    {
      text: 'SYSTEM NAME',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'deviceAC.systemName',
    },
    {
      text: 'SYSTEM AGE',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'deviceAC.systemAge',
    },
    {
      text: 'LAST SERVICE',
      align: 'start',
      sortable: false,
      filterable: true,
      value: 'deviceAC.lastServiceDate',
    },
    {
      text: 'HEALTH RATING',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'systemHealthRating',
    },
    {
      text: 'SERIAL NUMBER',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'deviceAC.uId',
    },
    {
      text: 'ALERTS',
      align: 'start',
      sortable: false,
      filterable: false,
      width: '110px',
      value: 'notificationAlert',
    },
    {
      text: 'CHANNEL',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'customer.companyName',
    },
    {
      text: 'FIRST ALERT',
      align: 'start',
      sortable: true,
      filterable: false,
      value: 'firstAlert',
    },
    {
      text: 'MOST RECENT ALERT',
      align: 'start',
      sortable: true,
      filterable: false,
      value: 'recentAlert',
    },
  ],
  alertsCategory: {
    performance: {
      count: 0,
      label: 'Performance',
      value: 'performance',
      nonSmacAdmin: true,
      active: true,
    },
    leak: {
      count: 0,
      label: 'Leak',
      value: 'leak',
      nonSmacAdmin: true,
      active: true,
    },
    filter: {
      count: 0,
      label: 'Filter',
      value: 'filter',
      active: true,
    },
    noAlerts: {
      count: 0,
      label: 'No Alerts',
      value: 'noAlerts',
      nonSmacAdmin: true,
      active: true,
    },
  },
});

export default initialState;
